import {KTCard} from '../../../_metronic/helpers'
import {ReorderingContext} from '../context'
import {Pagination} from '../../../utils/pagination'
import {ReorderSearchComponent} from '../sections/ReorderSearchComponent'
import ReorderingTable from '../sections/ReorderingTable'
import {useAppSelector} from '../../../redux/useTypedSelector'
import { useGetReorderingData } from '../hooks/useGetReorderingData'

function Reordering() {
  const {
    isFetchingCsvData,
    reorderingData,
    reorderFilters,
    pagination,
    monthly_column,
    onPageChange,
    isLoading,
    onSearch,
    onClearAll,
    onClickSorting,
    onDownloadCsv,
    onApplyFilters,
    reorderRefetch,
    onResetFilters,
    isOpeationLoading,
    handleSupplierChange,
    handleUserChange
  } = useGetReorderingData()
  const {user} = useAppSelector((state) => state.auth)
  const isUserExist = user?.is_owner
    ? false
    : JSON.parse(localStorage.getItem('is_supplier') || 'false')

  const contextValue = {
    isFetchingCsvData,
    isLoading,
    reorderingData,
    pagination,
    monthly_column,
    onPageChange,
    onSearch,
    onClearAll,
    onClickSorting,
    onDownloadCsv,
    reorderFilters: reorderFilters,
    onApplyFilters,
    reorderRefetch,
    onResetFilters,
    isOpeationLoading,
    isUserExist,
    handleSupplierChange,
    handleUserChange
  }

  return (
    <ReorderingContext.Provider value={contextValue}>
      <KTCard>
        <ReorderSearchComponent />
        <ReorderingTable />
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </KTCard>
    </ReorderingContext.Provider>
  )
}

export default Reordering
